import _ from "lodash";
import ACTIONS from "../actions/TestcacheActions";
import {filterTestcache} from "../../common/utils/FilterFunctions";
import {populateTestcacheFilterOptions} from "../../common/utils/PopulateFilterOptions";
import {setTestcacheFilters} from "../../common/utils/SetFilters";

const initialState = {
    TestcacheData: [],
    filtered_testcache_records: [],
    testcacheFilterOptions: {
        testcacheCountryOptions: [],
        testcacheDataSourceTypeOptions: [],
    },
    testcacheFilters: {
        testcacheCountryFilter: null,
        testcacheDataSourceTypeFilter: null,
    },
    testcache_filtered_state: true,
    all_testcache_records_selected: false,
    some_testcache_records_selected: false,
    selected_testcache_records: [],
    sourceTypeOptions: [],
}

const testcacheReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.TestcacheActionTypes.ALL_TESTCACHE_SELECTED: {
            let newState = _.cloneDeep(state);
            newState.all_testcache_records_selected = !newState.all_testcache_records_selected;
            const selectedRecordIds = action.payload.recordIds;
            newState.selected_testcache_records = action.payload.isSelected
                ? [...new Set([...selectedRecordIds])]
                : newState.selected_testcache_records.filter(selectedRecordId =>
                    !newState.selected_testcache_records.includes(selectedRecordId));
            return newState
        }

        case ACTIONS.TestcacheActionTypes.SOME_TESTCACHE_SELECTED: {
            let newState = _.cloneDeep(state);
            const selectedRecordId = [action.payload.recordId];
            newState.selected_testcache_records = action.payload.isSelected
                ? [...new Set([...newState.selected_testcache_records, ...selectedRecordId])]
                : newState.selected_testcache_records.filter(selectedRecordIds =>
                    !selectedRecordId.includes(selectedRecordIds));
            newState.some_testcache_records_selected = newState.selected_testcache_records.length > 0 &&
                !newState.all_testcache_records_selected
            return newState;
        }

        case ACTIONS.apiActionsTestcache.SET_TESTCACHE_DB_TABLE_DATA: {
            let newState = _.cloneDeep(state);
            newState.TestcacheData = action.payload;
            newState.filtered_testcache_records = newState.TestcacheData;
            newState.testcacheFilterOptions = populateTestcacheFilterOptions(newState.testcacheFilterOptions,
                newState.TestcacheData);
            newState.testcache_filtered_state = false;
            return newState;
        }

        case ACTIONS.TestcacheActionTypes.LOAD_SOURCE_TYPES: {
            let newState = _.cloneDeep(state);
            let sourceTypeAdded = []
            let sourceType = action.payload;
            sourceType.forEach(st => {
                if (!sourceTypeAdded.includes(st)) {
                    sourceTypeAdded.push(st);
                    newState.sourceTypeOptions.push({
                        value: st,
                        label: st
                    });
                }
            });
            return newState;
        }

        case ACTIONS.TestcacheActionTypes.SET_TESTCACHE_FILTER: {
            let newState = _.cloneDeep(state);
            newState.testcacheFilters = setTestcacheFilters(newState.testcacheFilters,
                action.payload.filterType, action.payload.filterOption);
            return newState;
        }

        case ACTIONS.TestcacheActionTypes.FILTER_TESTCACHE_RECORDS: {
            let newState = _.cloneDeep(state);
            newState.filtered_testcache_records = filterTestcache(newState.testcacheFilters, newState.TestcacheData);
            newState.testcache_filtered_state = true;
            return newState;
        }


        case ACTIONS.TestcacheActionTypes.CLEAR_TESTCACHE_DETAILS: {
            return initialState;
        }

        default:
            return state;
    }
}

export default testcacheReducer;
